import { spacing } from '../style';
import styled from '@emotion/styled';
import breakpoints from '../theme/material/breakpoints';

const sizes = {
  thin: {
    maxWidth: '420px',
  },

  medium: {
    maxWidth: '640px',
  },
};

const Container = styled('div')<{
  relative?: boolean;
  fullWidth?: boolean;
  width: 'thin' | 'medium';
  screenTop?: boolean;
  spacedBottom?: boolean;
}>(
  {
    padding: `0 ${spacing.PADDING_MD.padding}`,
    maxWidth: '1070px',
    margin: '0 auto',
  },

  ({ relative }) => {
    return relative ? { position: 'relative' } : null;
  },

  ({ fullWidth }) => {
    return fullWidth
      ? {
          [breakpoints.down(768.05)]: {
            padding: '0',
          },
        }
      : null;
  },

  ({ width }) => sizes[width],

  ({ screenTop }) => {
    return screenTop
      ? {
          [breakpoints.up(769)]: {
            ...spacing.MARGIN_TOP_LG,
            ...spacing.MARGIN_BOTTOM_LG,
          },
        }
      : null;
  },

  ({ spacedBottom }) => {
    return spacedBottom
      ? {
          [breakpoints.down(768.05)]: {
            ...spacing.MARGIN_BOTTOM_LG,
          },
        }
      : null;
  }
);

export default Container;
